<template>
  <button
    v-tooltip="user ? user.first_name + ' ' + user.last_name : ''"
    class="user-circle"
    :style="sizeStyle"
  >
    <template v-if="user">
      <img :src="imageUrl">
    </template>
    <!-- <template v-else>
      <div :style="fontStyle" :title="user.first_name + ' ' + user.last_name">
        {{ formatInitials() }}
      </div>
    </template> -->
  </button>
</template>

<script setup>
import {
  toRefs, computed,
} from 'vue';

const props = defineProps({
  user: {
    type: Object,
    default: () => {},
  },
  size: {
    type: [Number, String],
    default: null,
  },
});

const {
  user,
  size,
} = toRefs(props);

const imageUrl = computed(() => `/avatar/${user.value.username}`);

const sizeStyle = computed(() => {
  let w = size.value;
  let h = size.value;
  if (typeof size.value === 'number') {
    w = `${w}px`;
  }
  if (typeof size.value === 'number') {
    h = `${h}px`;
  }

  return {
    width: w,
    'max-width': w,
    height: h,
    'max-height': h,
  };
});

</script>

<style lang="scss" scoped>
.user-circle {
  display: flex;
  justify-content: center;
  align-items: center;
  border: none;
  border-radius: 50%;
  color: inherit;
  text-transform: uppercase;

  img {
    max-width: inherit;
    max-height: inherit;
  }
}
</style>
